import React, {useState} from 'react';
import TagBodyHeader from './TagBodyHeader';
import TagList from './TagList';
import TagAddModal from './modal/TagAddModal';


export default function TagBody(param) {

    const [projectId, setProjectId] = useState("-1");
    const [representiveCheck, setRepresentiveCheck] = useState(false);

    function callbackProjectId(projectId) {
        setProjectId(projectId);
    }

    function representiveAdd() {
        setRepresentiveCheck(!representiveCheck);
    }

    return(
        <div className="content-wrapper">
            <TagBodyHeader/>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">태그 조회</h3>
                                    {
                                        projectId !== "-1" && 
                                            <div className="card-header-image">
                                                <a href="" data-toggle="tooltip" title="대표태그 등록" data-toggle="modal" data-target="#tagAddModal" onClick={representiveAdd}><i className="fas fa-plus mr-1"></i>대표태그 등록</a>
                                            </div>
                                    }
                                    
                                </div>
                                <TagList callbackProjectId={callbackProjectId} representiveCheck={representiveCheck}></TagList>
                            </div>
                            {
                                projectId !== "-1" &&
                                    <div className="button-wrapper mb-5 col-12" >
                                        <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#tagAddModal" onClick={representiveAdd}><i className="fas fa-plus"></i> 대표 태그 등록</button>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </section>
            <TagAddModal />
        </div>
        
    );
}